import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ChannelModel } from 'src/app/hubadmin/shared/models/channel';
import { RegionModel } from 'src/app/hubadmin/shared/models/region';
import { StateModel } from 'src/app/hubadmin/shared/models/state';
import { PosmAudityTypesModel, VisibilityModel } from 'src/app/hubadmin/shared/models/visibility';
import { ChannelProvider } from 'src/app/hubadmin/shared/providers/channel.provider';
import { AdminDataProvider } from 'src/app/hubadmin/shared/providers/master-provider/admin-data.provider';
import { RegionProvider } from 'src/app/hubadmin/shared/providers/region.provider';
import { StateProvider } from 'src/app/hubadmin/shared/providers/state.provider';
import { VisibilityProvider } from 'src/app/hubadmin/shared/providers/visibility.provider';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ApiService } from 'src/app/services/http/api.service';
import { ToastClientService } from 'src/app/services/toast/toast-client.service';
import { AlertService } from 'src/app/shared/providers/AlertProvider';

@Component({
  selector: 'app-add-edit-cooler-audit-type',
  templateUrl: './add-edit-cooler-audit-type.component.html',
  styleUrls: ['./add-edit-cooler-audit-type.component.scss']
})
export class AddEditCoolerAuditTypeComponent implements OnInit {

  channels: ChannelModel[];
  regions: RegionModel[];
  states: StateModel[];
  _parameters: any;
  id: number;
  _form: FormGroup;
  submitted = false;
  @Input() model: PosmAudityTypesModel = new PosmAudityTypesModel();
  posmElements: VisibilityModel[];
  constructor(
    public apiService: ApiService,
    public apiConfig: ApiConfiguration,
    public toast: ToastClientService,
    public activatedRoute: ActivatedRoute,
    public adminDataProvider: AdminDataProvider,
    public channelProvider: ChannelProvider,
    public stateProvider: StateProvider,
    public regionProvider: RegionProvider,
    public visiblityProvider: VisibilityProvider,
    private router: Router,
    private formBuilder: FormBuilder,
    public alertService: AlertService,
    private ngxService: NgxUiLoaderService,
  ) {
    this._form = this.formBuilder.group({
      posm_element_config_id: ["", Validators.required],
      posm_image_template: [""],
      posm_image_banner: [""],
      image_planogram: [""],
      region_id: ["", Validators.required],
      state_code: ["", Validators.required],
      channel_id: ["", Validators.required],
    });
  }

  ngOnInit() {
    this._parameters = this.activatedRoute.params.subscribe((params) => {
      if (typeof params["id"] !== "undefined") {
        if (params["id"] !== "") {
          this.id = Number.parseInt(params["id"]);
          this.getPosmAuditTypes(this.id);
        }
      }
    });
    this.getStateList();
  }

  loaderStart() {
    try {
      this.ngxService.start();
    } catch (error) {
      console.log(error);
    }
  }
  loaderDismiss() {
    try {
      // this.loadingCntr.dismiss();
      this.ngxService.stop();
    } catch (error) { }
  }

  getPosmAuditTypes(id) {
    this.apiService
      .getHeaders(this.apiConfig.getPosmAuditTypes + "?id=" + id)
      .subscribe(
        (res: any) => {
          this.model = res.body.data as PosmAudityTypesModel;
          this.getFormModel();
          this.stateFilteredByRegion = this.states.filter(
            (i) => i.region_id == this.model.region_id
          );
        },
        (err) => {
          console.log(err);
        }
      );
  }

  getStateList(): void {
    this.apiService
      .getHeaders(this.apiConfig.configGetStates)
      .subscribe((res: any) => {
        this.states = res.body.data as StateModel[];
        this.states.forEach((s) => {
          s.id = s.state_code;
        });
        this.stateFilteredByRegion = this.states.filter(
          (i) => i.region_id == this.model.region_id
        );
      });
  }

  stateFilteredByRegion: StateModel[];

  onChangeRegion(item) {
    this.stateFilteredByRegion = this.states.filter(
      (s) => s.region_id == item && s.state_year == 2021
    );
  }

  // convenience getters for easy access to form fields
  get f() {
    return this._form.controls;
  }

  ngDoCheck() {
    this.regions = this.regionProvider.regions;
    this.states = this.stateProvider.state;
    this.channels = this.channelProvider.channels;
    this.posmElements = this.visiblityProvider.visibility;
    if (typeof this.posmElements != "undefined") {
      if (this.posmElements.length > 0) {
        this.posmElements = this.posmElements.filter(i => i.element_type == 2)
      }
    }
  }

  ngDestroy() {
    this._parameters.unsubscribe();
  }


  setFormModel() {
    this.model.region_id = this._form.controls['region_id'].value;
    this.model.state_code = this._form.controls['state_code'].value;
    this.model.channel_id = this._form.controls['channel_id'].value;
    this.model.posm_element_config_id = this._form.controls['posm_element_config_id'].value;
  }

  getFormModel() {
    this._form.controls['region_id'].setValue(this.model.region_id);
    this._form.controls['state_code'].setValue(this.model.state_code);
    this._form.controls['channel_id'].setValue(this.model.channel_id);
    this._form.controls['posm_element_config_id'].setValue(this.model.posm_element_config_id);
  }

  onSubmit() {
    this.setFormModel();
    this.submitted = true;
    if (this._form.invalid) {
      return;
    }
    if (this.model.id != null) {
      this.updatePosmTemplate();
    } else {
      this.createPosmTemplate();
    }
  }

  createPosmTemplate() {
    this.loaderStart();
    this.apiService
      .post(this.apiConfig.createPosmAuditTypes, this.model)
      .subscribe((res: any) => {
        if (res.status) {
          console.log(res.body.data.message)
          this.toast.Success(res.body.data.message);
          this.loaderDismiss();
          this.router.navigateByUrl("/hubAdmin/cooler-templates");
        }
      },
      (err) => {
        console.log(err);
        this.toast.Error(err);
        this.loaderDismiss();
      }
      );
  }

  updatePosmTemplate() {
    this.loaderStart();
    this.apiService
      .put(
        this.apiConfig.updatePosmAuditTypes + "?id=" + this.model.id,
        this.model
      )
      .subscribe((res: any) => {
        if (res.status) {
          console.log(res.data.message)
          this.toast.Success(res.data.message);
          this.loaderDismiss();
          this.redirectToAddAndEdit();
        }
      },
      (err) => {
        console.log(err);
        this.toast.Error(err);
        this.loaderDismiss();
      });
  }

  clearSuccess() {
    setTimeout(() => {
      this.alertService.clear(); // stop foreground spinner of the master loader with 'default' taskId
    }, 4000);
  }

  onSelectFilePosmTemplate(event) {
    if (event.target.files && event.target.files[0]) {
      let size = event.target.files[0].size;
      let imageSize;
      if (size < 1000 * 1000) {
        imageSize = size / 1000;
      }
      if (imageSize < 700) {
        let reader = new FileReader(); // Files reading using file class.
        reader.readAsDataURL(event.target.files[0]); // read file as data url.
        reader.onload = (event) => {
          this.model.posm_image_template = reader.result;
        };
      }
      else {
        let message = "Please upload image above 500kb less than 700kb"
        this.alertService.warning(message);
        this.clearSuccess();
        this._form.controls['posm_image_template'].setValue(null)
      }
    }
  }

  onSelectFilePosmBanner(event) {
    if (event.target.files && event.target.files[0]) {
      let size = event.target.files[0].size;
      let imageSize;
      if (size < 1000 * 1000) {
        imageSize = size / 1000;
      }
      if (imageSize < 700) {
        let reader = new FileReader(); // Files reading using file class.
        reader.readAsDataURL(event.target.files[0]); // read file as data url.
        reader.onload = (event) => {
          this.model.posm_image_banner = reader.result;
        };
      }
      else {
        let message = "Please upload image above 500kb less than 700kb"
        this.alertService.warning(message);
        this.clearSuccess();
        this._form.controls['posm_image_banner'].setValue(null)
      }
    }
  }

  onSelectFilePosmPlanogram(event) {
    if (event.target.files && event.target.files[0]) {
      let size = event.target.files[0].size;
      let imageSize;
      if (size < 1000 * 1000) {
        imageSize = size / 1000;
      }

      if (imageSize < 700) {
        let reader = new FileReader(); // Files reading using file class.
        reader.readAsDataURL(event.target.files[0]); // read file as data url.
        reader.onload = (event) => {
          this.model.image_planogram = reader.result;
        };
      }
      else {
        let message = "Please upload image above 500kb less than 700kb";
        this.alertService.warning(message);
        this.clearSuccess();
        this._form.controls['image_planogram'].setValue(null)
      }
    }
  }

  redirectToAddAndEdit() {
    this.router.navigateByUrl("/hubAdmin/cooler-templates");
  }

}
